import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import List from '@zenbusiness/zui/List';
import ListItem from '@zenbusiness/zui/ListItem';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './ShowCaseSection.styles';

import { useProductLandingContext } from '../../contexts/useProductLanding';

function ShowCaseSection() {
  const { formatMessage } = useIntl();
  const { productConfig } = useProductLandingContext();
  const { showCase: { title, stylesContainer = {}, stylesItem = {}, hasBorder, items = [] } = {} } = productConfig;

  // Styles props
  const { bgrColorContainer = 'default', variantContainer = 'elevation', sizeContainer = '' } = stylesContainer;
  const { bgrColorItem = 'paper', variantItem = 'elevation' } = stylesItem;

  if (items.length === 0) {
    return null;
  }

  return (
    <Stack gap={3}>
      {title && (
        <Heading component="h2" size="xl" wrap="wrap">
          <FormattedMessage id={title} />
        </Heading>
      )}
      <Styled.ShowCaseList
        component={List}
        length={items.length}
        color={bgrColorContainer}
        variant={variantContainer}
        {...(sizeContainer && { size: sizeContainer })}
      >
        {items.map((item) => (
          <Styled.ShowCaseItem
            key={item.image}
            component={ListItem}
            {...(!hasBorder && { variant: 'elevated' })}
            color={bgrColorItem}
            variant={variantItem}
          >
            {item.image && (
              <Styled.Image>
                <SharedAsset
                  alt={item.alt ? formatMessage({ id: item.alt }) : ''}
                  src={item.image}
                  sx={{ objectFit: 'cover' }}
                />
              </Styled.Image>
            )}
            {item.name && (
              <Styled.Content>
                <Text color="secondary" size="md" weight="regular">
                  <FormattedMessage id={item.name} />
                </Text>
              </Styled.Content>
            )}
          </Styled.ShowCaseItem>
        ))}
      </Styled.ShowCaseList>
    </Stack>
  );
}

export default ShowCaseSection;
